import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
      .then(registration => {
        console.log('ServiceWorker registered:', registration.scope);
      })
      .catch(err => {
        console.log('ServiceWorker registration failed:', err);
      });
  });
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Gracefully hide the static pre-loader after the app has been rendered.
const loader = document.getElementById('app-loader');
if (loader) {
  // Wait a moment for the app to paint, then start the fade out.
  setTimeout(() => {
    loader.classList.add('hidden');
    // Remove the element from the DOM after the transition is complete
    // to clean up and ensure it doesn't interfere with the app.
    loader.addEventListener('transitionend', () => loader.remove());
  }, 200);
}